'use strict';

angular.module('AcaApp').controller('SendController', [
  '$scope',
  '$mdDialog',
  '$location',
  '$window',
  '$interval',
  '$rootScope',
  '$route',
  'ShortcutsService',
  'EmployerService',
  'SendService',
  'AuxiliaryOperationsService',
  'SEND_MESSAGES',
  'OUTPUT_TYPE',
  'SETTINGS',
  'SettingsService',
  'XMIT_STATUS',
  'LayoutService',
  'UtilsService',
  'XMIT_PAGE',
  '$routeParams',
  'HIST_STATUS_TEXT',
  'AuxiliaryDataService',
  'LRJ_MANAGER',
  'ManagedUserInformationService',
  '$q',
  '$timeout',
  'ERROR',
  'CommonTransmittalService',
  'XmitToStateService',
  // jscs:disable maximumLineLength
  function(
    $scope,
    $mdDialog,
    $location,
    $window,
    $interval,
    $rootScope,
    $route,
    ShortcutsService,
    EmployerService,
    SendService,
    AuxiliaryOperationsService,
    SEND_MESSAGES,
    OUTPUT_TYPE,
    SETTINGS,
    SettingsService,
    XMIT_STATUS,
    LayoutService,
    UtilsService,
    XMIT_PAGE,
    $routeParams,
    HIST_STATUS_TEXT,
    AuxiliaryDataService,
    LRJ_MANAGER,
    ManagedUserInformationService,
    $q,
    $timeout,
    ERROR,
    CommonTransmittalService,
    XmitToStateService
  ){
    ManagedUserInformationService.checkManagedServices('send');
    $scope.showPNotes = false;
    $scope.pnotes = [];
    $scope.employerRecords = [];
    $scope.filesWithXmitrun = [];
    $scope.filesNames = [];
    $scope.xmitFiles = [];
    $scope.xmitFilesMS = [];
    $scope.xmitStFilesMS = [];
    $scope.options = {
      sendPage: $routeParams.section || 'send'
    };
    $scope.sendOptionFile = 'print';
    $scope.data = {};
    $scope.form = {
      selected: false,
      selectedOptions: false,
      selectedMark: 'N',
      PDFRequired: 'N'
    };
    $scope.selection = {ids: []};
    $scope.selectionsponsor = {ids: []};
    $scope.outputType = $rootScope.outputType || '';
    $scope.payerCheckBoxIdPrefix = '#payer_';
    $scope.sponsorCheckBoxIdPrefix = '#sponsor_';
    $scope.showFormOptions = false;
    $scope.selectedAllSponsor = false;
    $scope.transmittal = {
      step: ''
    };
    $scope.print = {
      step: ''
    };
    $scope.state = {
      selected: ''
    };
    $scope.xmitstate = {
      step: ''
    };
    $scope.parent = HIST_STATUS_TEXT.PARENTTRANSMITTAL;
    $scope.printStmtrun = {};
    $scope.showEmployerSponsorList = false;
    $scope.numberLabelPNotes = 3;
    $scope.numberMarkAsPrinted = 4;
    $scope.numberPDFIndex = 4;
    $scope.taxyear = $window.sessionStorage.taxYear;
    $scope.showPDFIndex = false;
    $scope.indexedPDFCost = '';
    $scope.backStXmit = false;
    var FILENAME_XMITRUN = 2;
    var FILENAME_PART = 3;
    var setShowPNotes = function(value){
      $scope.showPNotes = value;
    };
    var setShowPDFIndex = function(value){
      $scope.showPDFIndex = value;
    };
    var closeModal = function(){
      ShortcutsService.enableBackSpaceDefault();
      $mdDialog.hide();
    };
    $scope.checkAll = function(){
      for(var i = 0; i < $scope.employers.length; i++){
        if($($scope.payerCheckBoxIdPrefix + i) !== undefined) {
          $($scope.payerCheckBoxIdPrefix + i).prop('checked', true);
        }
      }
    };
    $scope.unCheckAll = function(){
      for(var i = 0; i < $scope.employers.length; i++){
        if($($scope.payerCheckBoxIdPrefix + i) !== undefined) {
          $($scope.payerCheckBoxIdPrefix + i).prop('checked', false);
        }
      }
    };
    $scope.checkAllSponsor = function(){
      if(!$scope.selectedAllSponsor){
        $scope.selectedAllSponsor = true;
      }
      _.each($scope.employersponsor, function(itm){
        itm.selected = $scope.selectedAllSponsor;
      });
    };
    $scope.unCheckAllSponsor = function(){
      if($scope.selectedAllSponsor){
        $scope.selectedAllSponsor = false;
      }
      _.each($scope.employersponsor, function(itm){
        itm.selected = $scope.selectedAllSponsor;
      });
    };
    $scope.selectSponsor = function(index){
      $scope.employersponsor[index].selected = (!$scope.employersponsor[index].selected);
    };
    $scope.closeModal = function(){
      closeModal();
    };
    $scope.closeModalXmitSt = function(){
      closeModal();
      $scope.options.sendPage = 'send';
      $route.reload();
    };
    $scope.closeModalMarkedXmitSt = function(){
      closeModal();
      $scope.goToSendTransmittalState()
    };
    var getNotAvailableURL = function(service){
      var defaultNotAvailablePage = 'app/views/send/modals/not-available.html';
      if($rootScope.services !== undefined){
        if($rootScope.services[service] !== undefined){
          if(!$rootScope.services[service].isAvailable){
            return defaultNotAvailablePage;
          }
          else if(!$rootScope.services[service].licenseAllows){
            return 'app/views/send/modals/not-available-' + service + '.html';
          }
        }
      }
      return defaultNotAvailablePage;
    };
    $scope.sendNotAvailableModal = function(service){
      setShowPNotes(false);
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: getNotAvailableURL(service),
        parent: angular.element(document.body)
      });
    };

    $scope.sendViewOptionsModal = function(){
      setShowPNotes(false);
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/view-options.html',
        parent: angular.element(document.body)
      });
    };

    $scope.generatePdf = function(){
      setPrintBasicInformation();
      $scope.options.sendPage = 'send-print';
      $scope.outputType = 'pdf';
      $scope.showFormOptions = true;
      setShowPNotes(false);
      setShowPDFIndex(false);
    };

    $scope.generatePrintService = function(){
      setPrintBasicInformation();
      $scope.print = {step: 1};
      $scope.options.sendPage = 'send-print';
      $scope.outputType = 'printservice';
      $scope.showFormOptions = false;
      $scope.form.PDFRequired = 'N';
      loadNoteList();
      loadIndexedPDFCost();
      setShowPNotes(true);
      setShowPDFIndex(true);
    };

    $scope.generateTransmittal = function(){
      $mdDialog.hide();
      $scope.transmittal = {step: 1};
      $scope.showFormOptions = false;
      setShowPNotes(false);
      setShowPDFIndex(false);
      EmployerService.GetEmployers1095ReadyToTransmit().then(function(data){
        $scope.employers = data.result;
      });
      $scope.options.sendPage = 'send-transmittal';
      $scope.outputType = 'aca';
    };

    $scope.generateStateTransmittal = function(){
      setPrintBasicInformation();
      $scope.backStXmit = false;
      $scope.outputType = 'state';
      $scope.options.sendPage = 'send-transmittal-states-options';
      $scope.subtitleXmitState = 'Generate State Transmittal';
      $scope.xmitstate.step = '1';
    };

    $scope.goToCheckListPage = function(hide){
      if(hide) $mdDialog.hide();
      $scope.xmitFiles.splice(0, $scope.xmitFiles.length);
      $scope.options.sendPage = SEND_MESSAGES.BACKCHECKLIST;
    };

    $scope.cancelTransmittal = function(xmitRun){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/cancel-transmittal.html',
        parent: angular.element(document.body)
      });
      CommonTransmittalService.cancelTransmittal(xmitRun, $scope);
      cleanSelections();
    };

    $scope.cancelPrint = function(stmtrun){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/cancel-print.html',
        parent: angular.element(document.body)
      });
      var fchar = getFcharSelected();
      var request = {
        StmtRun: parseInt(stmtrun),
        Fchar: fchar,
        JobId: $scope.jobId,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        Hash: $scope.hash,
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.PRINTSERVICE)
      };
      SendService.cancelPrint(request).then(
        function(data){
          $timeout(function(){
            $mdDialog.hide();
            if(data.result.Success){
              if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
                $scope.GoToHistoryPrintStatus();
              }
              else{
                $scope.options.sendPage = 'send';
                $scope.print.step = 1;
                $scope.outputType = 'print';
                cleanSelections();
              }
            }
            else{
              $scope.errorMessage = data.result.Error;
              $scope.options.sendPage = SEND_MESSAGES.PRINT_FILE_FAILED;
            }
          }, 5000);
        },
        function(error){
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    $scope.isManagedServices = function(){
      return ManagedUserInformationService.isManagedServices();
    };

    $scope.goToPrintConfirmationOk = function(){
      $scope.print = {step: 3};
    };

    $scope.sendXmit = function(transmittalFileName, xmitRun, ids){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/send-transmittal.html',
        parent: angular.element(document.body)
      });
      var jobId = $scope.jobId || 0;
      if (ids != undefined){
         jobId = ids.sort().join().toString();
      }
      var xmitRequest = {
        FileName: transmittalFileName.toString(),
        XmitRun: xmitRun.split(',').sort(UtilsService.compareNumbers).toString(),
        JobId: jobId,
        Hash: $scope.hash || $window.sessionStorage.hash,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL)
      };
      SendService.SendXmit(xmitRequest).then(
        function(data){
          var validStatus = data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED ||
            data.result.Xmit.StatusInt === XMIT_STATUS.IRS_PROCESSING ||
            data.result.Xmit.StatusInt === XMIT_STATUS.COMPLETE ||
            data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED_FOR_SUBMISSION;
          if(validStatus){
            $mdDialog.hide();
            if(data.result.isNpsCompleted !== 'Y'){
              $mdDialog.show({
                scope: $scope.$new(),
                preserveScope: true,
                templateUrl: 'app/views/questionIntegration/modals/question-integration.html',
                controller: 'QuestionIntegrationController'
              });
            }
            $scope.options.sendPage = 'send-xmit-success';
            $scope.transmittal.step = 3;
            $scope.outputType = 'aca';
          }
          else{
            $mdDialog.hide();
            $scope.options.sendPage = 'send-xmit-error';
            $scope.transmittal.step = 3;
            $scope.outputType = 'aca';
          }
        }.bind(this),
        function(error){
          var configuration = {
            titleMessage: ERROR.TRANSMITTAL.ERRORTITLE,
            actionMessage: ERROR.TRANSMITTAL.ERRORSENDTRANSMITTAL,
            supportAssistance: ERROR.TRANSMITTAL.SUPPORTASSIST,
            button: 'Back to Send Options'
          };
          errorOnTransmittal(error, configuration);
        }
      );
    };

    $scope.cancelStateTransmittal = function(xmitRun, filesNames, ids){
      var fileList = filesNames.toString();
      var metaInfoToEmailUser = { 
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: 'State ' + UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL),
        STXMITIND: xmitRun,
        jobId: ids.join()
      };
      SendService.cancelStateTransmittal(xmitRun, fileList, metaInfoToEmailUser).then(function(values){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/send/modals/cancel-state-transmittal.html',
          parent: angular.element(document.body)
        });
      }, function(error){
        console.log(error.data);
      });
    };

    $scope.cancelFederalTransmittal = function(filesNames, xmitRunList, ids){
      var cancelRequestXmit = {
        Fchar: $scope.form.selected,
        XmitRun: xmitRunList.toString(),
        JobId: (ids || []).join(),
        Hash: $scope.hash || window.sessionStorage.hash,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL)
      };
      SendService.cancelFederalTransmittal(filesNames.toString().toUpperCase(), cancelRequestXmit)
        .then(function(data){
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/send/modals/cancel-federal-transmittal.html',
              parent: angular.element(document.body)
            });
        }, function(error){
          $scope.configuration = {
            titleMessage: ERROR.TRANSMITTAL.ERRORTITLE,
            errorMessage: ERROR.TRANSMITTAL.ERRORCANCELTRANSMITTAL,
            supportAssistance: ERROR.TRANSMITTAL.SUPPORTASSIST,
            button: ERROR.TRANSMITTAL.BACK_OPTIONS_BUTTON
          };
          $scope.errorMessage = ERROR.TRANSMITTAL.ERRORCANCELTRANSMITTAL;
          $scope.options = {
            sendPage: ERROR.ERRORAPAGE
          };
          console.log(error.data);          
        });
    };

    $scope.markXmit = function(ids, xmitRun){
      var metaInfoToEmailUser = {
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: 'State ' + UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL),
        STXMITIND: xmitRun
      };        
      SendService.markAsTransmitted(ids.join(), metaInfoToEmailUser).then(
        function(data){
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/send/modals/mark-state-transmitted.html',
            parent: angular.element(document.body)
          });
        },
        function(error){
          console.log(error.data);
        }
      );
    };

    $scope.sendToState = function(xmitRun, filesNames, state, ids){
      var requestStateXmit = {
        filename: filesNames.join(),
        xmitrun: xmitRun.split(',').sort(UtilsService.compareNumbers).toString(),
        state: state,
        jobid: ids.sort().join().toString(),
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID()
      }
      SendService.sendStateXmit(requestStateXmit).then(
        function(data){
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/send/modals/transmit-to-state.html',
            parent: angular.element(document.body)
          });
        },
        function(error){
          console.log(error.data);
        }
      );
    };

    var errorOnTransmittal = function(error, configuration){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      $mdDialog.hide().finally(function(){
        $scope.sendOptionFile = 'transmittal';
        showMessageFromSend(error, configuration);
      });
    };

    var setPrintBasicInformation = function(){
      loadEmployersList();
      getTinMaskinSetting();
    };

    $scope.goSend = function(){
      if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
        $scope.goToStatusPage();
        return;
      }
      $location.search({});
      $location.path('/send');
      $route.reload();
    };

    var setEmployerData = function(data){
      $scope.employersponsor = [];
      $scope.employers = data[0].result;
      var sponsorList = data[1].result;
      _.each($scope.employers, function(element){
        _.each(sponsorList, function(el){
          if(element.ptin === el.ptin){
            $scope.employersponsor.push(element);
          }
        });
      });
      $scope.employersponsor.splice(0,0,
				    {
				      ptin: 'No Employer Sponsor',
				      pname: ''
				    }
				   );
    };

    var loadEmployersList = function(){
      $q.all([
        EmployerService.GetEmployerRecords(),
        EmployerService.GetEmployerSponsors()
      ]).then(setEmployerData);
    };

    $scope.goTo = function(path){
      $location.path(path);
    };

    $scope.back = function(){
      if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
        ManagedUserInformationService.checkManagedServices($scope.outputType);
      }
      $scope.options.sendPage = 'send';
      $scope.errorMessage = '';
      cleanSelections();
    };

    $scope.goTo1094C = function(){
      $scope.options.sendPage = 'send-1094c';
    };

    $scope.backcheck = function(){
      if($scope.xmitFiles.length > 0){
        $scope.options.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATUS;
      }
      else if($scope.xmitFilesMS.length > 0){
        $scope.GoToSendTransmittalPage();
      }
      else{
        $scope.options.sendPage = SEND_MESSAGES.BACKCHECKLIST;
      }
    };

    $scope.backcheckStatus = function(){
      $scope.options.sendPage = ($scope.backStXmit) ? XMIT_PAGE.SEND_TRANSMITTAL_STATES : 'send';
    };

    var cleanSelections = function(){
      $scope.form.selected = false;
      $scope.form.selectedOptions = false;
      $scope.selection = '';
      $scope.state.selected = '';
      $scope.showEmployerSponsorList = false;
      $scope.numberLabelPNotes = 3;
      $scope.numberMarkAsPrinted = 4;
      $scope.numberPDFIndex = 4;
    };

    $scope.sendPdfConfirmation = function(){
      var rpcPrintRequest = setBatchPrintConfig(OUTPUT_TYPE.PDF);
      if(rpcPrintRequest === true){
        return ;
      }
      executeBatchPrint('app/views/send/modals/send-processing-pdf.html', rpcPrintRequest);
    };

    $scope.sendPrintServiceConfirmation = function(){
      var rpcPrintRequest = setBatchPrintConfig(OUTPUT_TYPE.PRINTSERVICE);
      if(rpcPrintRequest === true){
        return ;
      }
      executeBatchPrintLrj('app/views/send/modals/send-data.html', rpcPrintRequest);
    };

    $scope.sendTransmittalConfirmation = function(){
      var rpcTransmittalRequest = setTransmittalConfig(OUTPUT_TYPE.TRANSMITTAL);
      if(rpcTransmittalRequest === true){
        return true;
      }
      if(getFcharSelected() === 'X5C'){
        autoPopulateBox20(rpcTransmittalRequest);
      }
      executeTransmittal('app/views/send/modals/send-processing-transmittal.html', rpcTransmittalRequest);
    };

    $scope.sendTransmittalConfirmationDocgen = function(){
      var rpcTransmittalRequest = setTransmittalConfig(OUTPUT_TYPE.TRANSMITTAL);
      if(rpcTransmittalRequest === true){
        return true;
      }
      if(getFcharSelected() === 'X5C'){
        autoPopulateBox20(rpcTransmittalRequest);
      }
      executeTransmittalWithDocgen('app/views/send/modals/send-processing-transmittal.html', rpcTransmittalRequest);
    };

    $scope.sendStateTransmittalConfirmation = function(){
      var rpcStateTransmittalRequest = setStateTransmittalConfig(OUTPUT_TYPE.STATE_TRANSMITTAL);
      if(rpcStateTransmittalRequest === true){
        return ;
      }
      $q.all([
        SendService.isThereAnyIncompleteRecord(rpcStateTransmittalRequest),
        SendService.isThereAnyOrphanRecord(rpcStateTransmittalRequest)
      ]).then(function(data){
        if(data[0].result.value === true || data[1].result.value === true){
          $scope.options.sendPage = 'generated-file-failed';
        }
        else executeStateTransmittal('app/views/send/modals/send-waiting-transmittal.html', rpcStateTransmittalRequest);
      },
      function(error){
        console.log('Error', error);
      })
    };

    $scope.IsAvailable = function(service){
      if($rootScope.services !== undefined){
        if($rootScope.services[service] !== undefined){
          return ($rootScope.services[service].isAvailable && $rootScope.services[service].licenseAllows);
        }
      }
      return false;
    };

    $scope.TransmittalSummaryByEmployers = function(xmitInfo){
      $scope.xmitrun = xmitInfo.stmtrun;
      if(xmitInfo.status !== 'In Process'){
        SendService.GetEmployerInfoInTransmittal($scope.xmitrun).then(function(response){
          $scope.employersIncludeInXmit = response.result.RecordsEmployer;
          $scope.xmitdetails = _.each(response.result.ArrayTransmittalDetailByXmit, function(element){
            element.xmitdate = LayoutService.formatAMPM(element.xmitdate);
          });
          xmitInfo.filenameresponse = response.result.filenameresponse;
          setDataStatusDetail(xmitInfo);
          $scope.options.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATUS_DETAIL;
        },
								      function(error){
									console.log(error);
								      }
								     );
      }
      else{
        $scope.findJob(xmitInfo);
      }
    };

    $scope.goToStatusPage = function(){
      if($scope.outputType.toUpperCase() === OUTPUT_TYPE.TRANSMITTAL || $scope.outputType.toUpperCase() === OUTPUT_TYPE.TRANSMITTALSPLIT){
        $scope.GoToSendTransmittalPage();
      }
      else{
        $scope.GoToHistoryPrintStatus();
      }
    };

    var buildShowname = function(filename) {
      if(!filename || filename === '-') 
        return '-';
      var filenameSplit = filename.split('~');
      return filenameSplit[FILENAME_XMITRUN] + '~' + filenameSplit[FILENAME_PART];
    };

    $scope.GoToSendTransmittalPage = function(){
      $mdDialog.hide();
      AuxiliaryDataService.getLrjStatusList(LRJ_MANAGER.JOBTYPE.XMIT).then(function(data){
        $scope.xmitFiles = _.each(data.result, function(element){
          element.createdon = LayoutService.formatAMPM(element.createdon);
          element.finishedon = (element.finishedon !== undefined)
            ? LayoutService.formatAMPM(element.finishedon)
            : undefined;
          element.employer = (element.employer !== undefined) ? element.employer.replace(/'/g, '') : '';
          element.showname = buildShowname(element.filename);
        });
        $scope.parent = HIST_STATUS_TEXT.PARENTTRANSMITTAL;
        $scope.options.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATUS;
      }, function(error){
        console.log('Error: ' + error);
      });
    };

    $scope.goToSendTransmittalState = function() {
      XmitToStateService.getFilesTransmittedToState().then(function(data){
        $scope.xmitFilesToState = _.each(data.result, function(element){
          var filename = element.filename.split('~');
          var filenameUppercase = element.filename.toUpperCase();
          if (filenameUppercase.includes('.XML') || filenameUppercase.includes('.CANCEL')) {
            if (filename[FILENAME_PART]){
              element.filename = filename[FILENAME_XMITRUN] + '~' + filename[FILENAME_PART];
            }
            else {
              element.filename = filename[FILENAME_XMITRUN]
            }
          }
          if (filenameUppercase.includes('.TXT')) {
            element.filename = filename[FILENAME_XMITRUN];
          }
          element.createdate = LayoutService.formatAMPM(element.createdate);
        });
        $scope.backStXmit = true;
        $scope.parent = HIST_STATUS_TEXT.PARENTSTATETRANSMITTAL;
        $scope.options.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATES;
      });
    };

    $scope.editXmitState = function(file){
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        controller: 'SendXmitToStateController',
        templateUrl: 'app/views/send/modals/edit-xmit-state.html',
        locals: {
          file: file
        }
      });
    };

    $scope.GoToHistoryPrintStatus = function(){
      AuxiliaryDataService.getLrjStatusList(LRJ_MANAGER.JOBTYPE.PRINT).then(function(data){
        $scope.printFiles = data.result;
        $scope.printFiles = _.each(data.result, function(element){
          element.createdon = LayoutService.formatAMPM(element.createdon);
          element.finishedon = (element.finishedon !== undefined)
            ? LayoutService.formatAMPM(element.finishedon)
            : undefined;
          element.employer = (element.employer !== undefined) ? element.employer.replace(/'/g, '') : '';
        });
        $scope.parent = HIST_STATUS_TEXT.PARENTPRINT;
        $scope.options.sendPage = 'print-history-data';
      }, function(error){
        console.log('Error: ' + error);
      });
    };

    $scope.findJob = function(job){
      var tpl = checkStatusLrj(job.status);
      if(tpl !== ''){
        $scope.jobId = job.jobid;
        setFcharSelected(job.type);
        $scope.statusPage = true;
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: tpl,
          parent: angular.element(document.body)
        });
      }
    };

    $scope.printDetailByStmtrun = function(message){
      $scope.currentDetail = message;
      if(message.status !== 'In Process'){
        var fchar = (message.type === '1095-B') ? 'X5B' : 'X5C';
        var stmtrun = (message.stmtrun !== undefined) ? parseInt(message.stmtrun) : 0;
        var jobid = message.jobid;
        $q.all([
          SendService.getPrintDetailByStmtRun(stmtrun, fchar),
          SendService.getPrintHistory(stmtrun, jobid)
        ]).then(function(data){
          $scope.printRecords = data[0].result.RecordsEmployer;
          $scope.printHistory = _.each(data[1].result, function(element){
            element.updatedate = LayoutService.formatAMPM(element.updatedate);
          });
          $scope.options.sendPage = SEND_MESSAGES.PRINT_STATUS_DETAIL;
        });
      }
      else{
        $scope.findJob(message);
      }
    };

    var checkStatusLrj = function(status){
      var template = '';
      switch(status){
      case HIST_STATUS_TEXT.APPROVEWAITINGFORPRINTING:
        $scope.titleModalStatus = HIST_STATUS_TEXT.APPROVEWAITINGFORPRINTING;
        $scope.messageModalStatus = HIST_STATUS_TEXT.WAITINGMESSAGE;
        template = 'app/views/send/modals/subbmitted-waiting-printing.html';
        break;
      case HIST_STATUS_TEXT.READYFORSUBMISSION:
      case HIST_STATUS_TEXT.FAILED:
      case HIST_STATUS_TEXT.INPROCESS:
        template = 'app/views/send/modals/send-data.html';
        break;
      case HIST_STATUS_TEXT.SUBMITTEDFORPRINTING:
        $scope.titleModalStatus = HIST_STATUS_TEXT.SUBMITTEDFORPRINTING;
        $scope.messageModalStatus = HIST_STATUS_TEXT.SUBMITTEDFORPRINTING;
        template = 'app/views/send/modals/subbmitted-waiting-printing.html';
        break;
      }
      return template;
    };

    var getRpcRequest = function(outputType){
      return {
        Fchar: getFcharSelected(),
        Payers: getPayerSelected(),
        EmployerSponsors: ($scope.outputType === 'pdf' || $scope.outputType === 'printservice') ? getSponsorSelected() : '',
        Output: outputType,
        FilingStatus: 'Original',
        TransmittalType: 'New Originals',
        State: ($scope.outputType === 'state') ? getStateSelected() : ''
      };
    };

    var setTransmittalConfig = function(outputType){
      if(aRequiredOptionIsMissing() === true){
        return true;
      }
      var rpcTransmittalRequest = getRpcRequest(outputType);
      return rpcTransmittalRequest;
    };

    var setBatchPrintConfig = function(outputType){
      if(aRequiredOptionIsMissing() === true){
        return true;
      }
      $scope.errorMessage = '';
      var rpcPrintRequest = getRpcRequest(outputType);
      rpcPrintRequest.PrintOption = (!$scope.form.selectedOptions) ? '' : $scope.form.selectedOptions;
      rpcPrintRequest.LocalPrint = $scope.form.selectedMark;
      if($scope.showPNotes === true){
        rpcPrintRequest.PnoteKey = $scope.data.selectedPNote;
      }
      rpcPrintRequest.TinMask = $scope.TinMask;
      if($scope.showPDFIndex === true){
        rpcPrintRequest.PdfRequired = $scope.form.PDFRequired;
      }
      return rpcPrintRequest;
    };

    var setStateTransmittalConfig = function(outputType){
      if(aRequiredOptionIsMissing() === true){
        return true;
      }
      $scope.errorMessage = '';
      var rpcStateTransmittalRequest = getRpcRequest(outputType);
      return rpcStateTransmittalRequest;
    };

    var finishServiceJob = function(renewToken){
      $scope.jobProcessing = false;
      $interval.cancel(renewToken);
      $mdDialog.hide();
    };

    var executeBatchPrint = function(url, rpcPrintRequest){
      $scope.jobProcessing = true;
      var renewToken = $interval(
        function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
        }, SETTINGS.RENEWTOKEN_EACH_MILLISECONDS
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: url,
        parent: angular.element(document.body)
      });
      SendService.runBatchPrint(rpcPrintRequest).then(
        function(data){
          finishServiceJob(renewToken);
          $scope.token = $window.sessionStorage.token;
          $scope.print = {step: 2};
          $scope.showfilename = UtilsService.splitFilename(String(data.result.Filename));
          $scope.filename = 'PRINT~' + $scope.showfilename;
          $scope.options.sendPage = 'send-file-created';
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          finishServiceJob(renewToken);
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    var executeBatchPrintLrj = function(url, rpcPrintRequest){
      SendService.runBatchPrintLrj(rpcPrintRequest).then(
        function(data){
          $scope.jobId = data.result.DataInt;
          $scope.type = LRJ_MANAGER.JOBTYPE.PRINT;
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: url,
            parent: angular.element(document.body)
          });
        },
        function(error){
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    var autoPopulateBox20 = function(rpcTransmittalRequest){
      SendService.autoPopulateBox20(rpcTransmittalRequest).then(
        function(error){
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    var executeTransmittal = function(url, rpcTransmittalRequest){
      SendService.callXmit(rpcTransmittalRequest).then(
        function(data){
          $scope.jobId = data.result.DataInt;
          $scope.type = LRJ_MANAGER.JOBTYPE.XMIT;
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: url,
            parent: angular.element(document.body)
          });
        },
        function(error){
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    var executeTransmittalWithDocgen = function(url, rpcTransmittalRequest){
      $scope.jobProcessing = true;
      var renewToken = $interval(
        function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
        }, SETTINGS.RENEWTOKEN_EACH_MILLISECONDS
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: url,
        parent: angular.element(document.body)
      });
      SendService.generateDocgenFederalXmit(rpcTransmittalRequest).then(
        function(data){
          $scope.jobProcessing = false;
          $interval.cancel(renewToken);
          $mdDialog.hide();
          $scope.options.sendPage = 'send-transmittal-failed';
          if(data.result.value){
            $scope.options.sendPage = 'send-transmittal-generated';
          }
        },
        function(error){
          finishServiceJob(renewToken);
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    var executeStateTransmittal = function(url, rpcPrintRequest){
      $scope.jobProcessing = true;
      var renewToken = $interval(
        function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
        }, SETTINGS.RENEWTOKEN_EACH_MILLISECONDS
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: url,
        parent: angular.element(document.body)
      });
      SendService.generateStateXmit(rpcPrintRequest).then(
        function(data){
          $scope.jobProcessing = false;
          $interval.cancel(renewToken);
          $mdDialog.hide();
          $scope.options.sendPage = 'send-transmittal-failed';
          if(data.result.value){
            $scope.options.sendPage = 'send-state-transmittal-generated';
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          finishServiceJob(renewToken);
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    $scope.getTotal = function(){
      var total = 0;
      _.each($scope.employerRecords, function(employer){
        total += totals(employer);
      });
      return total;
    };

    var totals = function(employer){
      return ($scope.outputType == OUTPUT_TYPE.PRINTSERVICE.toLowerCase()) ? employer.FormCount : employer.SubscriberCount;
    };

    $scope.GoToReviewTransmit = function(xmit){
      $scope.arrayXmitRun = [];
      $scope.filesNames = [];
      $scope.ids = [];
      var counts = [];
      var xmitFileList = (_.isEmpty($scope.xmitFiles)) ? $scope.xmitFilesMS : $scope.xmitFiles;
      if(xmit.jobid != 0){
        _.each(xmitFileList, function(e){
          if(e.jobid == xmit.jobid){
            $scope.arrayXmitRun.push(e.stmtrun);
            // for DocGen Transmitals 
            if(e.acaxmitjobid)
              $scope.ids.push(e.acaxmitjobid);
          }
        });
      }
      else{
        $scope.arrayXmitRun.push(xmit.stmtrun);
      }
      $scope.jobId = xmit.jobid;
      $scope.xmitRun = $scope.arrayXmitRun.toString();
      ($scope.arrayXmitRun.length > 1) ? $scope.outputType = 'split' : $scope.outputType = 'aca';
      SendService.GetEmployerInfoInTransmittal($scope.arrayXmitRun.toString()).then(function(response){
        $scope.employerRecords.splice(0, $scope.employerRecords.length);
        response.result.RecordsEmployer.forEach(function(element){
          counts[element.StmtRun] = (counts[element.StmtRun]||0)+1;
          element.countRows = counts[element.StmtRun];
          _.each(xmitFileList, function(e){
            if(e.stmtrun == element.StmtRun){
              if(e.splitMS){
                element.showfilename = e.filename;
                element.filename = 'X~' + e.filename;
              }
              else{
                $scope.FileParts = UtilsService.splitFilenameXmit(String(e.filename));
                element.showfilename = $scope.FileParts[2] + '~' + $scope.FileParts[3];
                element.filename = $scope.FileParts[1] + '~' + element.showfilename;
              }
              if(!_.contains($scope.filesNames, element.showfilename)){
                $scope.filesNames.push(element.showfilename);
              }
            }
          });
          $scope.employerRecords.push(element);
        });
        orderByXmitRunAndRowSpan();
        $scope.options.sendPage='send-transmittal';
        if(xmit.type === '1094-C'){
          $scope.transmittal.step = 1094;
        }
        else{
          $scope.transmittal.step = 2;
        }
        setFcharSelected(xmit.type);
        $scope.token = $window.sessionStorage.token;
      },
										    function(error){
										      console.log(error);
										    }
										   );
    };

    var orderByXmitRunAndRowSpan = function(){
      $scope.employerRecords.sort(function(a, b){
        var aXmitRun = a.StmtRun;
        var bXmitRun = b.StmtRun;
        var aRowSpan = a.countRows;
        var bRowSpan = b.countRows;
        if(aXmitRun == bXmitRun){
          return (aRowSpan > bRowSpan) ? -1 : (aRowSpan < bRowSpan) ? 1 : 0;
        }
        else{
          return (aXmitRun < bXmitRun) ? -1 : 1;
        }
      });
    };

    $scope.GoToReviewStateTransmit = function(xmitst){
      $scope.arrayXmitRun = [];
      $scope.filesNames = [];
      $scope.ids = [];
      $scope.parentIds = [];
      var counts = [];
      var xmitStFileList = (_.isEmpty($scope.xmitFilesToState)) ? $scope.xmitStFilesMS : $scope.xmitFilesToState;
      $scope.arrayXmitRun = _.filter(xmitStFileList, function(el){
        if(el.parentid !== 0){
          if(xmitst.id === el.id || xmitst.parentid == el.parentid || xmitst.id == el.parentid){
            $scope.ids.push(el.id);
            $scope.parentIds.push(el.parentid);
            return el;
          }
        }
        else {
          if(xmitst.id === el.id || xmitst.parentid === el.id){
            $scope.ids.push(el.id);
            $scope.parentIds.push(el.parentid);
            return el;
          }
        }
      });
      $scope.jId = xmitst.id;
      $scope.xmitRun = _.map($scope.arrayXmitRun, function(el){ return el.xmitrun;}).toString();
      $scope.outputType = ($scope.arrayXmitRun.length > 1) ? 'split' : 'aca';
      SendService.GetEmployerInfoInTransmittal($scope.xmitRun).then(function(response){
        $scope.employerRecords.splice(0, $scope.employerRecords.length);
        response.result.RecordsEmployer.forEach(function(element){
          counts[element.StmtRun] = (counts[element.StmtRun]||0)+1;
          element.countRows = counts[element.StmtRun];
          element.state = xmitst.state;
          element.id = xmitst.id;
          element.parentid = xmitst.parentid;
          _.each(xmitStFileList, function(e){
            if(e.xmitrun == element.StmtRun){
              element.showfilename = e.filename;
              element.filename = 'X~' + e.filename;
              if(!_.contains($scope.filesNames, element.showfilename)){
                $scope.filesNames.push(element.showfilename);
              }
            }
          });
          $scope.employerRecords.push(element);
        });
        orderByXmitRunAndRowSpan();
        $scope.options.sendPage = 'send-transmittal-states-options';
        $scope.subtitleXmitState = 'Transmit to State';
        $scope.xmitstate.step = '2';

        setFcharSelected(xmitst.form);
        $scope.token = $window.sessionStorage.token;
      },
								    function(error){
								      console.log(error);
								    }
								   );
    };

    $scope.GoToReviewPrint = function(print){
      $scope.printStmtrun.stmtRun = print.stmtrun;
      $scope.jobId = print.jobid;
      $scope.outputType = 'printservice';
      setFcharSelected(print.type);
      getPrintDetailByStmtRun($scope.printStmtrun.stmtRun, $scope.form.selected);
      $scope.token = $window.sessionStorage.token;
      $scope.showfilename = UtilsService.splitFilename(print.filename);
      $scope.filename = 'PRINT~' + $scope.showfilename;
    };

    $scope.backListXmitStatus = function(){
      if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
        $route.reload();
        return;
      }
      $scope.options.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATUS;
    };

    $scope.showEmailAddress = function(){
      SendService.getManagedServicesEmailList().then(function(data){
        var dataEmail = {};
        switch($scope.outputType.toUpperCase()){
        case OUTPUT_TYPE.TRANSMITTAL:
        case OUTPUT_TYPE.TRANSMITTALSPLIT:
          dataEmail = {
            listEmails: data.result,
            CodeTypeRun: $scope.xmitRun,
            FileName: $scope.filesNames.toString(),
            Fchar: $scope.form.selected,
            JobId: ($scope.jobId === undefined) ? 0 : $scope.jobId,
            TypeFile: SETTINGS.TRANSMITTAL,
            TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL),
            OutputType: $scope.outputType,
            ids: ($scope.ids) ? $scope.ids.toString() : 0,
            parentIds: ($scope.parentIds) ? $scope.parentIds.toString(): 0
          };
          break;
        case OUTPUT_TYPE.PRINTSERVICE:
          dataEmail = {
            listEmails: data.result,
            CodeTypeRun: $scope.printStmtrun.stmtRun.toString(),
            FileName: $scope.showfilename,
            Fchar: $scope.form.selected,
            JobId: $scope.jobId,
            TypeFile: SETTINGS.PRINTSERVICE,
            TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.PRINTSERVICE),
            OutputType: $scope.outputType
          };
          break;
        }
        $mdDialog.show({
          scope: $scope,
          templateUrl: 'app/views/send/modals/send-email-to-approve.html',
          parent: angular.element(document.body),
          preserveScope: true,
          controller: 'SendEmailController as seCont',
          locals: {
            dataEmail: dataEmail
          }
        });
      });
    };

    $scope.approvePrintFiles = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/send-approve-print-warning.html',
        parent: angular.element(document.body)
      });
    }

    $scope.insertPrintFiles = function(){
      $scope.disablePrint = true;
      var dataPrintFiles = {
        StmtRun: $scope.printStmtrun.stmtRun,
        Fchar: $scope.form.selected,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Cid: ManagedUserInformationService.getCID(),
        JobId: $scope.jobId,
        Customer: ManagedUserInformationService.getCustomerName(),
        Hash: $scope.hash,
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.PRINTSERVICE)
      };
      SendService.savePrintFiles(dataPrintFiles).then(function(data){
        $scope.disablePrint = false;
        if(data.result.DataBool){
          var confirm = $mdDialog.confirm({
            templateUrl: 'app/views/send/modals/send-print-approved-successfully.html',
            parent: angular.element(document.body),
            controller: 'DialogController'
          });
          $mdDialog.show(confirm).then(function(){
            $scope.GoToHistoryPrintStatus();
          });
        }
        else{
          $scope.messageApprovePrint = data.result.DataString;
          $scope.messageApprovePrintClass = SEND_MESSAGES.ERRORMESSAGECLASS;
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/send/modals/send-approve-print-confirmation.html',
            parent: angular.element(document.body)
          });
        }
      });
    };

    var showMessageFromSend = function(error, configuration){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      if(error.data.error.frontend_message !== undefined && error.data.error.frontend_message !== ''){
        $scope.errorMessage = error.data.error.frontend_message;
      }
      else{
        $scope.errorMessage = 'System Error';
      }
      if(configuration === undefined){
        $scope.options.sendPage = SEND_MESSAGES.PRINT_FILE_FAILED;
      }
      else{
        configuration.errorMessage = $scope.errorMessage;
        $scope.configuration = configuration;
        $scope.options.sendPage = ERROR.ERRORAPAGE;
      }
    };

    var aRequiredOptionIsMissing = function(){
      if($scope.form.selected === false){
        $scope.errorMessage = SEND_MESSAGES.NOFORMSELECTED;
        return true;
      }

      if($scope.form.selectedOptions === false && $scope.showFormOptions){
        $scope.errorMessage = SEND_MESSAGES.NOFORMSELECTED;
        return true;
      }
      if($scope.employers.length === 0){
        if(getFcharSelected() === 'X5B' && ($scope.outputType === 'pdf' || $scope.outputType === 'printservice')){
          if($scope.employersponsor.length === 0){
            $scope.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
            return true;
          }
        }
        else{
          $scope.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
          return true;
        }
      }
      else{
        var isPayerSelected = false;
        var isPayerSponsorSelected = false;
        for(var i = 0; i < $scope.employers.length; i++){
          var isChecked = $($scope.payerCheckBoxIdPrefix + i).prop('checked');
          if(isChecked) {
            isPayerSelected = true;
            break;
          }
        }
        if($scope.outputType === 'pdf' || $scope.outputType === 'printservice'){
          for(var i = 0; i < $scope.employersponsor.length; i++){
            if(($scope.employersponsor[i].selected)){
              isPayerSponsorSelected = true;
              break;
            }
          }
        }
        if(!isPayerSelected){
          if(getFcharSelected() === 'X5B' && ($scope.outputType === 'pdf' || $scope.outputType === 'printservice')){
            if(!isPayerSponsorSelected){
              $scope.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
              return true;
            }
          }
          else{
            $scope.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
            return true;
          }
        }
        if($scope.outputType === 'state' && getStateSelected() === ''){
          $scope.errorMessage = SEND_MESSAGES.NOSTATESELECTED;
          return true;
        }
      }
    };

    var getTinMaskinSetting = function(){
      SettingsService.getTinMaskSetting().then(
        function(data){
          $scope.TinMask = data.result.value;
        }
      );
    };

    var getPayerSelected = function(){
      var payers = '';
      for(var i = 0; i < $scope.employers.length; i++){
        if($($scope.payerCheckBoxIdPrefix + i).prop('checked')){
          payers += $($scope.payerCheckBoxIdPrefix + i).attr('ng-true-value') + ',';
        }
      }
      payers = payers.replace(/'/g, '');
      return payers.slice(0, -1);
    };

    var getSponsorSelected = function(){
      var sponsor = '';
      for(var i = 0; i < $scope.employersponsor.length; i++){
        if($scope.employersponsor[i].selected){
          sponsor += $scope.employersponsor[i].ptin + ',';
        }
      }
      sponsor = sponsor.replace(/'/g, '');
      return sponsor.slice(0, -1);
    };

    var getStateSelected = function(){
      return $scope.state.selected;
    };

    var getFcharSelected = function(){
      return $scope.form.selected;
    };

    var setFcharSelected = function(formType){
      if($scope.form !== undefined && $scope.form.selected !== undefined){
        selectFchar(formType);
      }
      else{
        $scope.form = {
          selected: selectFchar(formType)
        };
      }
    };

    var selectFchar = function(form){
      switch(form){
      case '1095-B':
        $scope.form.selected = 'X5B';
        break;
      case '1095-C':
        $scope.form.selected = 'X5C';
        break;
      case '1094-C':
        $scope.form.selected = '0';
        break;
      }
    };

    var setNotesData = function(data){
      $scope.pnotes = data.result.notes;
      if($scope.pnotes === undefined){
        $scope.pnotes = [];
      }
    };

    var loadNoteList = function(){
      SettingsService.getNotes().then(setNotesData);
    };

    var loadIndexedPDFCost = function(){
      SettingsService.getIndexedPDFCost().then(
	function(data){
          $scope.indexedPDFCost = data.result.value;
	});
    };

    var getMultipleSubscribersExistence = function(){
      SendService.GetMultipleSubscribersExistence().then(
	function(data){
          if(data.result.Status){
            $scope.token = $window.sessionStorage.token;
            $scope.showfilename = UtilsService.splitFilename(String(data.result.FileName));
            $scope.filename = 'REPORT~' + $scope.showfilename;
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/send/modals/warning-multiple-subscribers.html',
              parent: angular.element(document.body)
            });
          }
          else{
            getUncoveredIndividuals();
          }
	});
    };

    var getUncoveredIndividuals = function(){
      $mdDialog.hide();
      if($scope.taxyear >= '2017'){
        SendService.GetUncoveredIndividuals().then(
          function(data){
            if(data.result.Status){
              $scope.token = $window.sessionStorage.token;
              $scope.showfilename = UtilsService.splitFilename(String(data.result.FileName));
              $scope.filename = 'REPORT~' + $scope.showfilename;
              $mdDialog.show({
		scope: $scope.$new(),
		templateUrl: 'app/views/send/modals/warning-uncovered-individuals.html',
		parent: angular.element(document.body)
              });
            }
          });
      }
    };

    $scope.getUncoveredIndividuals = function(){
      getUncoveredIndividuals();
    };

    var isPrintServiceLicense = function(){
      var noPrintServiceLicense = 'NP';
      return ($window.sessionStorage.isDemo == 'false' && $window.sessionStorage.userLicense.substring(0, 2) != noPrintServiceLicense && !$rootScope.isReadOnly);
    };

    $scope.isPrintServiceLicense = function(){
      return isPrintServiceLicense();
    };

    var setServicesStatus = function(){
      var sendServiceEnabledKey = 'ENABLED';
      var sendPath = '/send';
      if($location.path() === sendPath) {
        if($rootScope.services === undefined){
          $rootScope.services = {
            PDF: {
              isAvailable: false,
              licenseAllows: false
            },
            PRINTSERVICES: {
              isAvailable: false,
              licenseAllows: false
            },
            TRANSMITTAL: {
              isAvailable: false,
              licenseAllows: false
            },
            STATE_TRANSMITTAL: {
              isAvailable: false,
              licenseAllows: false
            }
          };
        }
        SettingsService.GetServicesStatus().then(function(data){
          $rootScope.services = {
            PDF: {
              isAvailable: isAvailableByTY(data.result.PDF),
              licenseAllows: true
            },
            PRINTSERVICES: {
              isAvailable: isAvailableByTY(data.result.PrintServices),
              licenseAllows: isPrintServiceLicense()
            },
            TRANSMITTAL: {
              isAvailable: isAvailableByTY(data.result.Transmittal),
              licenseAllows: !$rootScope.isReadOnly
            },
            STATE_TRANSMITTAL: {
              isAvailable: isAvailableByTY(data.result.StateTransmittal),
              licenseAllows: true
            }
          };
        });
      }
    };

    var isAvailableByTY = function(sendType){
      var availableTY = false;
      sendType.split(',').forEach(function(year){
        if(year === $scope.taxyear){
          availableTY = true;
        }
      });
      return availableTY;
    };

    var setDataStatusDetail = function(xmitData){
      $scope.token = $window.sessionStorage.token;
      $scope.FileParts = UtilsService.splitFilenameXmit(String(xmitData.filename));
      $scope.showfilename = $scope.FileParts[2] + '~' + $scope.FileParts[3];
      $scope.filename = $scope.FileParts[1] + '~' + $scope.showfilename;
      if(xmitData.filenameresponse !== undefined){
        $scope.FileParts = UtilsService.splitFilenameXmit(String(xmitData.filenameresponse));
        $scope.showfilenameresponse = $scope.FileParts[2] + '~' + $scope.FileParts[3];
        $scope.filenameresponse = $scope.FileParts[1] + '~' + $scope.showfilenameresponse;
      }
      else{
        $scope.showfilenameresponse = undefined;
        $scope.filenameresponse = undefined;
      }
      $scope.xmitStatus = xmitData.status;
      $scope.xmitEmployers = xmitData.employer;
      $scope.xmitFormtype = xmitData.type;
      $scope.xmitNumofforms = xmitData.nform;
      $scope.xmitTimeoftransmittal = LayoutService.formatAMPM(xmitData.createdon);
      $scope.xmitXmitrun = xmitData.stmtrun;
    };

    var getPrintDetailByStmtRun = function(stmtrun, fchar){
      SendService.getPrintDetailByStmtRun(stmtrun, fchar).then(function(data){
        if(!_.isEmpty(data.result)){
          $mdDialog.hide();
          $scope.employerRecords = data.result.RecordsEmployer;
          $scope.print = {step: 2};
          $scope.options.sendPage = SEND_MESSAGES.SENDPRINT;
          $scope.outputType = 'printservice';
        }
        else{
          $scope.options.sendPage = SEND_MESSAGES.PRINT_DETAIL_FAIL;
        }
      },
							       function(error){
								 $mdDialog.hide().finally(function(){
								   showMessageFromSend(error);
								 });
							       });
    };

    var routeToSection = function(){
      var dataParams = $routeParams;
      try{
        var section = dataParams.section;
        switch(section){
        case SEND_MESSAGES.SENDPRINT:
        case SEND_MESSAGES.SENDXMIT:
          ManagedUserInformationService.findDataToApprove(dataParams.param, function(data){
            if(!_.isEmpty(data)){
              if(data.Status === 'enabled'){
                $scope.hash = data.Hash;
                if($scope.taxyear !== data.arrayApproval['taxyear']){
                  changeTaxYear(data.arrayApproval['taxyear'], data);
                }
                else{
                  checkActionType(data);
                }
              }
              else{
                $scope.outputType = data.arrayApproval['output'];
                $scope.options.sendPage = SEND_MESSAGES.PRINT_ALREADY_APPROVED;
              }
            }
            else{
              $scope.options.sendPage = SEND_MESSAGES.PRINT_FILE_FAILED;
            }
          });
          break;
        case SEND_MESSAGES.PRINTHISTORYDATA:
          $scope.parent = HIST_STATUS_TEXT.PARENTPRINT;
          $scope.GoToHistoryPrintStatus();
          break;
        case XMIT_PAGE.SEND_TRANSMITTAL_STATUS:
        case XMIT_PAGE.XMIT_STATUS:
          $scope.parent = HIST_STATUS_TEXT.PARENTTRANSMITTAL;
          $scope.GoToSendTransmittalPage();
          break;
        case XMIT_PAGE.SEND_STATE_TRANSMITTAL_STATUS:
          $scope.parent = HIST_STATUS_TEXT.PARENTSTATETRANSMITTAL;
          $scope.goToSendTransmittalState();
          break;
        }
      }catch(e){
        console.error(e.name + ': ' + e.message);
      }
    };

    var checkActionType = function(data){
      switch(data.arrayApproval['output'].toUpperCase()){
      case OUTPUT_TYPE.TRANSMITTAL:
      case OUTPUT_TYPE.TRANSMITTALSPLIT:
        var jobid = parseInt(data.arrayApproval['jobid']);
        if (jobid !== 0 ){
          var xmit = {
            stmtrun: data.arrayApproval['codetyperun'],
            jobid: jobid,
            type: checkFchar(data.arrayApproval['fchar']),
            filename: data.arrayApproval['filename'],
            section: true
          };
          var ids = data.arrayApproval['ids'].split(',');
          var stmtrunList = data.arrayApproval['codetyperun'].split(',');
          var filenameList = data.arrayApproval['filename'].split(',');
          stmtrunList.forEach(function(el, idx){
            var dataXmitFiles = {
              jobid: jobid,
              filename: filenameList[idx],
              stmtrun: el,
              splitMS: true,
              acaxmitjobid: ids[idx]
            };
            $scope.xmitFilesMS.push(dataXmitFiles);
          });
          $scope.GoToReviewTransmit(xmit);
        }
        else{
          var xmit = {
            xmitrun: data.arrayApproval['codetyperun'].split(',')[0],
            jobid: jobid,
            type: checkFchar(data.arrayApproval['fchar']),
            filename: data.arrayApproval['filename'],
            section: true,
            id: parseInt(data.arrayApproval['ids'].split(',')[0]),
            parentid: parseInt(data.arrayApproval['parentIds'].split(',')[0]),
            form: checkFchar(data.arrayApproval['fchar']),
            state: data.arrayApproval['filename'].substring(0,2)
          };
          var xmitrun = data.arrayApproval['codetyperun'].split(',');
          var filenameList = data.arrayApproval['filename'].split(',');
          var ids = data.arrayApproval['ids'].split(',');
          var parentIds = data.arrayApproval['parentIds'].split(',');
          xmitrun.forEach(function(el, idx){
            var dataXmitFiles = {
              jobid: 0,
              filename: filenameList[idx],
              id: parseInt(ids[idx]),
              parentid: parseInt(parentIds[idx]),
              xmitrun: el,
              splitStMS: true
            };
            $scope.xmitStFilesMS.push(dataXmitFiles);
          });
          $scope.GoToReviewStateTransmit(xmit);
        }
        break;
      case OUTPUT_TYPE.PRINTSERVICE:
        getPrintDetailByStmtRun(parseInt(data.arrayApproval['codetyperun']), data.arrayApproval['fchar']);
        $scope.hash = data.Hash;
        $scope.printStmtrun.stmtRun = data.arrayApproval['codetyperun'];
        $scope.form.selected = data.arrayApproval['fchar'];
        $scope.jobId = data.arrayApproval['jobid'];
        $scope.token = $window.sessionStorage.token;
        $scope.showfilename = data.arrayApproval['filename'];
        $scope.filename = 'PRINT~' + $scope.showfilename;
        break;
      }
    };

    var checkFchar = function(fchar){
      var typeFchar;
      switch(fchar){
      case 'X5B':
        typeFchar = '1095-B';
        break;
      case 'X5C':
        typeFchar = '1095-C';
        break;
      case '0':
        typeFchar = '1094-C';
        break;
      }
      return typeFchar;
    };

    $scope.isCalifornia = function(state, taxyear){
      return (taxyear > '2019' && state == 'CA');
    };

    var changeTaxYear = function(taxyear, data){
      $q.all([SettingsService.changeTaxYear(taxyear), SettingsService.updateTaxYearInJwt(taxyear)]).then(function(values){
        $window.sessionStorage.taxYear = taxyear;
        $window.sessionStorage.token = values[1].result.value;
        $scope.taxyear = taxyear;
        checkActionType(data);
      }, function(error){
        console.log(error.data);
      });
    };

    $rootScope.$on('FINISH_XMIT', function(event, data){
      if(data !== undefined){
        $scope.filesNames = [];
        var filesXmitRun = [];
        var xmitRunIds = [];
        var counts = [];
        var progress = [];
        var idXmitrun = [];
        var progressList = data.filter(function(e){
          return e.match(/Id\: /);
        });
        _.each(progressList, function(p){
          getFileNameWithXmitrun(p);
          progress.push(
            p.split('\n').filter(function(e){
              return !e.match(/^Xmit Payers - Lrj\: /);
            })
          );
        });
        _.each(progress, function(pr){
          idXmitrun.push(
            pr.filter(function(e){
              return e.match(/^Id\: /);
            })
          );
        });
        _.each(progress, function(p){
          p.filter(function(e){
            filesXmitRun.push(e.match(/^FileName\: /));
          });
        });
        _.each(idXmitrun, function(xm){
          xm.forEach(function(e){
            xmitRunIds.push(
              UtilsService.getXmitRunIds(e)
            );
          });
        });
        $scope.xmitRun = xmitRunIds.toString();
        (xmitRunIds.length > 1) ? $scope.outputType = 'split' : $scope.outputType = 'aca';
        SendService.GetEmployerInfoInTransmittal(xmitRunIds.toString()).then(function(response){
          $scope.employerRecords.splice(0, $scope.employerRecords.length);
          response.result.RecordsEmployer.forEach(function(element){
            $mdDialog.hide();
            counts[element.StmtRun] = (counts[element.StmtRun]||0)+1;
            element.countRows = counts[element.StmtRun];
            element.filename = $scope.filesWithXmitrun[element.StmtRun];
            $scope.FileParts = UtilsService.splitFilenameXmit(String(element.filename));
            element.showfilename = $scope.FileParts[2] + '~' + $scope.FileParts[3];
            element.filename = $scope.FileParts[1] + '~' + element.showfilename;
            if(!_.contains($scope.filesNames, element.showfilename)){
              $scope.filesNames.push(element.showfilename);
            }
            $scope.employerRecords.push(element);
          });
          orderByXmitRunAndRowSpan();
          $scope.options.sendPage = 'send-transmittal';
          $scope.transmittal.step = 2;
          $scope.token = $window.sessionStorage.token;
        },
									     function(error){
									       $mdDialog.hide();
									       console.log(error);
									     });
      }
    });

    var getFileNameWithXmitrun = function(data){
      var idx = data.replace(/\n/g, ' ').match(/(?:Id:)(.+)(?:FileName:)/)[1].trim();
      var value = data.replace(/\n/g, ' ').match(/(?:FileName:)(.*)/)[1].trim();
      $scope.filesWithXmitrun[idx] = value;
    };

    $rootScope.$on('FINISH_XMIT_ERROR', function(event, data){
      var progressList = data
          .filter(function(e){
            return e.match(/ Error\: /);
          })
          .map(function(e){
            return e.split(' Error: ')[1];
          });

      $scope.errorMessage = '';
      $scope.errorMessageXmit = progressList[0].split('\n');
      $mdDialog.hide();
      $scope.options.sendPage = 'send-xmit-error-lrj';
    });

    $rootScope.$on('FINISH_PRINT', function(event, data){
      var progressList = data.filter(function(e){
        return e.match(/^Id\: /);
      });
      $scope.printStmtrun = UtilsService.getStmtRun(progressList[0]);
      getPrintDetailByStmtRun($scope.printStmtrun.stmtRun, $scope.form.selected);
      $scope.token = $window.sessionStorage.token;
      $scope.showfilename = UtilsService.getFileNameFromLrj(data);
      $scope.filename = 'PRINT~' + $scope.showfilename;
    });

    $rootScope.$on('FINISH_PRINT_ERROR', function(event, data){
      var progressList = data
          .filter(function(e){
            return e.match(/ Error\: /);
          })
          .map(function(e){
            return 'Error: ' + e.split('Error:')[1];
          });

      var values = _.uniq(progressList).join(' - ');
      $mdDialog.hide();
      $scope.errorMessage = values || 'System Error';
      $scope.options.sendPage = SEND_MESSAGES.PRINT_FILE_FAILED;
    });

    $scope.showEmployerSponsorOptions = function(){
      if($scope.outputType === 'pdf' || $scope.outputType === 'printservice'){
        $scope.numberLabel = ($scope.showFormOptions) ? 4 : 3;
        $scope.showEmployerSponsorList = ($scope.form.selected == 'X5B');
        $scope.numberLabelPNotes = ($scope.showEmployerSponsorList) ? 4 : 3;
        $scope.numberMarkAsPrinted = ($scope.showEmployerSponsorList) ? 5 : 4;
        $scope.numberPDFIndex = ($scope.showEmployerSponsorList) ? 5 : 4;
        $scope.unCheckAllSponsor();
      }
    };

    $scope.showStateOption = $scope.taxyear != '2019';

    routeToSection();
    setServicesStatus();
    getMultipleSubscribersExistence();
  }
]);
